import { render, staticRenderFns } from "./VMSAutoComplete.vue?vue&type=template&id=f1194fbc"
import script from "./VMSAutoComplete.vue?vue&type=script&lang=ts"
export * from "./VMSAutoComplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports